import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-encabezado-component',
  templateUrl: './encabezado.component.html',
  styleUrls: ['./encabezado.component.scss'],
})
export class EncabezadoComponent implements OnInit, OnChanges {
  @Input() tituloResaltadoEnRojo!: string;
  @Input() restoDelTitulo!: string;
  @Input() verBotonFiltros: boolean = true;
  @Input() verBotonNuevo: boolean = false;
  @Input() textoBotonNuevo: string = '';
  @Input() actualizarCollapsed: boolean = false;

  @Output() botonNuevoClick = new EventEmitter<void>();
  @Output() dataEmitter = new EventEmitter<any>();

  collapsed: boolean = true;

  constructor() {}

  ngOnInit(): void {
    null;
  }

  ocultarFiltros() {
    this.collapsed = !this.collapsed;
    this.dataEmitter.emit(this.collapsed);
  }

  onBotonNuevoClick() {
    this.botonNuevoClick.emit();
  }
  ngOnChanges(): void {
    this.collapsed = this.actualizarCollapsed;
  }
}
